import { render, staticRenderFns } from "./searchInpt.vue?vue&type=template&id=2ef0fd80&scoped=true"
import script from "./searchInpt.vue?vue&type=script&lang=js"
export * from "./searchInpt.vue?vue&type=script&lang=js"
import style0 from "./searchInpt.vue?vue&type=style&index=0&id=2ef0fd80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef0fd80",
  null
  
)

export default component.exports